/**
 * FounderGuard — wraps a route/page so only founders (see founder.ts) can view it.
 * Non-founders get a friendly "founders only" notice instead of the page.
 */
import type { ReactNode } from 'react';
import { useAuth } from './AuthContext.js';
import { isFounder } from './founder.js';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

export function FounderGuard({ children }: { children: ReactNode }) {
  const { user } = useAuth();
  if (!isFounder(user)) {
    return (
      <div className="p-6">
        <Alert variant="destructive">
          <AlertTitle>Founders only</AlertTitle>
          <AlertDescription>
            LoRA Training is restricted to founders. Ask Leslie if you need access.
          </AlertDescription>
        </Alert>
      </div>
    );
  }
  return <>{children}</>;
}
